export function getIsInCampaignsOrOverviewPage() {
  const isInCampaigns = window.location.href.includes('campaign/vnext/campaigns');
  const isInOverview = window.location.href.includes('campaign/vnext/overview');

  // should only render if it is in campaigns or overview page
  return isInCampaigns || isInOverview;
}
